// eslint-disable-next-line import/prefer-default-export
export const BxMergeCells = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1534 2.59863H20.9034V3.34863V20.6509V21.4009H20.1534H12.3555H12.271H3.84668H3.09668V20.6509V3.34863V2.59863H3.84668H12.271H12.3555H20.1534ZM11.2501 4.09863V8.91798H12.7501V4.09863H19.4034V11.4H19.1997H15.7032L16.7763 10.4491L17.2254 10.0511L16.4296 9.15301L15.9805 9.55094L13.7234 11.5509L13.2167 12L13.7234 12.4491L15.9805 14.4491L16.4296 14.847L17.2254 13.9489L16.7763 13.5509L15.7032 12.6H19.1997H19.4034V19.9009H12.7396V15.3486H11.2396V19.9009H4.59668V12.6H4.79981H8.29633L7.22318 13.5509L6.77412 13.9489L7.56996 14.847L8.01903 14.4491L10.2761 12.4491L10.7828 12L10.2761 11.5509L8.01903 9.55094L7.56996 9.15301L6.77412 10.0511L7.22318 10.4491L8.29633 11.4H4.79981H4.59668V4.09863H11.2501Z"
      fill="#2C2E34"
    />
  </svg>
)
